import { useTranslation } from 'react-i18next'
import { Base } from '@itsrever/design-system'

export const NoData = () => {
  const { t } = useTranslation()
  return <Base.EmptyState className="h-full" title={t('no_data.title')} />
}
